// extracted by mini-css-extract-plugin
export default {"customMenu":"MultiSelectDropdownMenu_customMenu__dTAsO"};